/** 测量 ↔ 设计树 双向同步重入保护。 */
let isMeasureToTreeSyncInProgress = false;

/**
 * 在设计树 → 测量 同步期间抑制测量回流，避免循环写入。
 *
 * @param action 同步动作。
 * @returns 动作返回值。
 */
export function runTreeToMeasureSelectionSync<T>(action: () => T): T {
  isMeasureToTreeSyncInProgress = true;
  try {
    return action();
  } finally {
    isMeasureToTreeSyncInProgress = false;
  }
}

/**
 * 判断当前是否应抑制测量 → 设计树 回流。
 *
 * @returns 是否抑制测量回流。
 */
export function isMeasureToTreeSyncSuppressed(): boolean {
  return isMeasureToTreeSyncInProgress;
}

/**
 * 在测量 → 设计树 写入期间执行动作。
 *
 * @param action 写入动作。
 * @returns 动作返回值。
 */
export function runMeasureToTreeSelectionSync<T>(action: () => T): T {
  isMeasureToTreeSyncInProgress = true;
  try {
    return action();
  } finally {
    isMeasureToTreeSyncInProgress = false;
  }
}
